var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-4 mx-2 border-neutral-500",class:{'border-l-2':_vm.highlighted==true}},[_c('div',{staticClass:"p-2 select-none cursor-pointer hover:bg-neutral-200 text-neutral-800",class:_vm.customClass,on:{"click":function($event){return _vm.onClicked()}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }